import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { api } from '../api/client.js';
import { ReportView } from '../components/ReportView.js';
export function ReportPage() {
    const { jobId } = useParams();
    const [job, setJob] = useState(null);
    const [report, setReport] = useState(null);
    const [error, setError] = useState('');
    useEffect(() => {
        if (!jobId)
            return;
        let interval;
        async function poll() {
            try {
                const result = await api.getScanStatus(jobId);
                setJob(result.data);
                if (result.data.status === 'completed') {
                    clearInterval(interval);
                    const rep = await api.getReport(jobId);
                    setReport(rep.data);
                }
                else if (result.data.status === 'failed') {
                    clearInterval(interval);
                    setError(result.data.error_message || 'Scan failed');
                }
            }
            catch {
                clearInterval(interval);
                setError('Failed to fetch status');
            }
        }
        poll();
        interval = setInterval(poll, 2000);
        return () => clearInterval(interval);
    }, [jobId]);
    if (error) {
        return (_jsxs("main", { className: "max-w-3xl mx-auto px-4 py-24 text-center", children: [_jsx(XCircle, { className: "w-8 h-8 text-danger mx-auto mb-3" }), _jsx("p", { className: "text-danger", children: error })] }));
    }
    if (report)
        return _jsx(ReportView, { data: report });
    return (_jsx("main", { className: "max-w-3xl mx-auto px-4 py-24", children: _jsxs("div", { className: "card text-center", children: [_jsxs("svg", { className: "animate-spin w-8 h-8 text-brand mx-auto mb-4", viewBox: "0 0 24 24", fill: "none", children: [_jsx("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), _jsx("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" })] }), _jsxs("h2", { className: "text-lg font-semibold text-white mb-2", children: ["Analyzing ", job?.domain || 'domain', "..."] }), job && (_jsxs(_Fragment, { children: [_jsx("div", { className: "w-full max-w-xs mx-auto bg-surface-200 rounded-full h-1.5 mb-2", children: _jsx("div", { className: "bg-brand h-1.5 rounded-full transition-all duration-500", style: { width: `${job.progress}%` } }) }), _jsx("p", { className: "text-surface-600 text-sm", children: job.progress_message || 'Processing...' })] }))] }) }));
}
